import PersonIcon from '@material-ui/icons/Person';
import { UserSubscriptionsList, UserSubscriptionsEdit } from './views';

export default {
  edit: UserSubscriptionsEdit,
  list: UserSubscriptionsList,
  icon: PersonIcon,
  name: 'user-subscription',
};
